import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client, { resolveMedia } from "../lib/api";

/* Minimal full-bleed embed player for iframes. No chrome, no nav.
 * Use: <iframe src="/embed/:id" /> from any site (Wix, Notion, etc).
 */
export default function Embed() {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    client.get(`/videos/${id}`)
      .then((r) => setVideo(r.data))
      .catch(() => setError("unavailable"));
    client.post(`/videos/${id}/view`).catch(() => {});
  }, [id]);

  if (error) return <div className="h-screen w-screen flex items-center justify-center bg-black text-zinc-500 text-sm" data-testid="embed-error">Signal lost.</div>;
  if (!video) return <div className="h-screen w-screen bg-black" data-testid="embed-loading" />;

  const isShort = video.type === "short";
  const playback = resolveMedia(video.playback_url);
  const poster = resolveMedia(video.thumbnail);

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center" data-testid="embed-page">
      <video
        src={playback}
        poster={poster}
        controls
        playsInline
        autoPlay
        muted
        loop={isShort}
        className={`max-h-full max-w-full ${isShort ? "h-full w-auto" : "w-full h-auto"}`}
      />
      <a
        href={`${process.env.REACT_APP_BACKEND_URL || ""}/watch/${video.id}`}
        target="_top"
        rel="noopener"
        className="absolute bottom-3 left-3 px-3 h-8 leading-8 text-[10px] uppercase tracking-widest font-bold rounded-full bg-black/60 backdrop-blur border border-[#FF6B00]/40 text-[#FFB800] hover:text-white hover:border-[#FF6B00] transition-colors"
        data-testid="embed-watch-link"
      >
        ⚡ Watch on Nexus
      </a>
    </div>
  );
}
